
import utils, { UTILS } from '../../utils'

var GROUP_DATA_MANAGER = {
    // 处理分组数据
    getGroupData(groupArr) {
        var groupData = [];
        for (var j = 0; j < groupArr.length; j++) {
            var data = {
                'id': groupArr[j].id,
                'f_name': groupArr[j].f_name.slice(0, 17),
                'choosed': false,
                'group_list': [],
                'group_time': groupArr[j].f_time
            }
            groupData.push(data);
        }
        // 合并默认未分组部分
        var defaultData = { 'id': 0, 'f_name': '未分组', 'choosed': true, 'group_list': [], 'group_time': 0 };
        groupData.push(defaultData);
        groupData.sort((a, b) => {return b.group_time - a.group_time});
        console.log('getGroupData-----', groupData);
        return groupData;
    },
    // 获取分组列表数据:分组管理移动分组的时候底部弹出框应用到
    getGroupDataList(groupData) {
        var groupList = [];
        for(var data of groupData){
            groupList.push({
                'text': data.f_name,
                'value': data.id
            })
        }
        return groupList;
    },
    // 更新分组数据
    updateGroupData(origiData, newData) {
        console.log('updateGroupData-------', origiData, newData);
        if(origiData.length == 0){
            origiData = origiData.concat(newData);
        }else{
            console.log('newData-----', newData);
            for(var data of newData) {
                var index = UTILS.getIdIndexInObjectArray(origiData, data.id);
                if(index != -1){
                    // 处理旧的分组内的RecordData的列表数据
                    if(data['group_list'].length > 0) {
                        for(var newData of data['group_list']){
                            // 处理新分组数据
                            var oIndex = UTILS.getIdIndexInObjectArray(origiData[index]['group_list'], newData.id);
                            if(oIndex != -1){
                                origiData[index]['group_list'].splice(oIndex, 1);
                                origiData[index]['group_list'][oIndex] = newData;
                            }else{
                                origiData[index]['group_list'].push(newData);
                            }
                            // 处理旧分组数据
                            origiData.forEach(ooData => {
                                ooData['group_list'].forEach(orData => {
                                    if(orData.id == newData.id && orData.groupId != newData.groupId){
                                        var index = UTILS.getIdIndexInObjectArray(ooData['group_list'], orData.id);
                                        ooData['group_list'].splice(index, 1);
                                    }
                                })
                            })
                        }
                    }
                }else{
                    // 处理新分组
                    origiData.push(data);
                }

                
            }
            
        }
        origiData.sort((a, b) => {return b.group_time - a.group_time});
        return origiData;
    },
    // 编辑命盘or新增命盘未刷新列表数据的时候手动更新本地分组数据
    updateGroupDataByData(origiData, newData) {
        console.log('updateGroupDataByData------', origiData, newData);
        for(var data of origiData){
            var groupList = data['group_list'];
            var index = UTILS.getIdIndexInObjectArray(groupList, newData.id);
            if(index != -1){
                if(data.id == newData.groupId) {
                    // 更新了非分组信息
                    groupList[index] = newData;
                }else{
                    // 修改了分组,在修改record数据的时候已经push过了 Todo:::冗余优化
                    groupList.splice(index, 1);
                }
            }else{
                if(data.id == newData.groupId) {
                    groupList.push(newData);
                }
            }
        }
        return origiData;
    },
    // 增加一条分组数据
    addGroupData(origiData, groupData) {
        var newData = { 
            'id': groupData.id, 
            'f_name': groupData.f_name.slice(0, 17), 
            'group_time': groupData.f_time,
            'group_list': [],
            'choosed': false
        };
        origiData.push(newData);
        origiData.sort((a, b) => {return b.group_time - a.group_time});
        return origiData;
    },
    // 删除一条分组数据
    deleteGroupData(origiData, groupId) {
        for(var data of origiData) {
            var index = origiData.indexOf(data);
            if(data.id == groupId){
                origiData.splice(index, 1);
            }
        }
        return origiData;
    },
    // 通过groupId获取groupData
    getGroupDataById(origiData, groupId){
        for(var data of origiData){
            if(data.id == groupId){
                return data;
            }
        }
        return null;
    },
    // 通过groupId获取groupName
    getGroupNameById(origiData, groupId) {
        for(var data of origiData) {
            if(data.id == groupId) {
                return data.f_name;
            }
        }
        return '';
    },
    // 改变分组数据
    changeGroupData(origiData, selectedGroupDataList, groupId) {

        // 先处理一下传递过来的已选择的分组数据以便后续的计算
        var selectedGroupData = {};
        for (var i = 0; i < selectedGroupDataList.length; i++) {
            var item = selectedGroupDataList[i];
            // 处理一下数据
            if(!selectedGroupData[item[1]]){
                selectedGroupData[item[1]] = [];
            }
            selectedGroupData[item[1]].push(item[0])
        }
        console.log("changeGroupData----", selectedGroupData, groupId);
        var targetIndex = UTILS.getIdIndexInObjectArray(origiData, groupId);
        var targetList = origiData[targetIndex]['group_list'];
        var targetName = this.getGroupNameById(origiData, groupId);
        // 遍历已选择的分组数据
        for(var keys in selectedGroupData){

            var selectedList = selectedGroupData[keys];
            var index = UTILS.getIdIndexInObjectArray(origiData, keys);
            var groupList = origiData[index]['group_list'];
            console.log("selectedList----", selectedList);

            for(var selectedId of selectedList) {
                var startIndex = UTILS.getIdIndexInObjectArray(groupList, selectedId);
                var targetIndex = UTILS.getIdIndexInObjectArray(targetList, selectedId);
                console.log("checkIndex----startIndex:::", startIndex, 'targetIndex:::', targetIndex);
                
                // 转移与目标组在同一组时只修改数据取消选择
                if(targetIndex != -1){
                    targetList[targetIndex].selected = false;
                }
                // 需要转移的数据:只处理在选中数组列表里，不在目标数组里的数据
                if(startIndex != -1 && targetIndex == -1){
                    // 处理数据的选中状态及修改数据的分组名
                    groupList[startIndex].selected = false;
                    groupList[startIndex]['group'] = targetName;
                    groupList[startIndex]['groupId'] = groupId;
                    // 注:要先push再splice，splice之后groupList已经改变了
                    targetList.push(groupList[startIndex]);
                    groupList.splice(startIndex, 1);
                }
            }
        }
    },
    // 删除分组数据
    deleteGroupListGroupData(origiData, selectedList) {
        for(var arr of selectedList) {
            var dataId = arr[0], groupId = arr[1];
            var groupIndex = UTILS.getIdIndexInObjectArray(origiData, groupId);
            // console.error('deleterrrrrrrrrrr-----', arr, groupIndex)
            var groupList = origiData[groupIndex]['group_list'];
            var dataIndex = UTILS.getIdIndexInObjectArray(groupList, dataId);
            groupList[dataIndex].selected = false;
            groupList.splice(dataIndex, 1);
        }
        return origiData;
    }
}

export {
    GROUP_DATA_MANAGER
}